import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { userExportColumns } from '../../config/exportColumns/userExportColumns'
import { appGetAllUser } from '../../store/user'
import ExportButton from '../../common/ExportButton'

function User() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Users</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllUser({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									loading: false,
								}),
							)
						}
						columns={userExportColumns}
						fileName="Users"
						sheetName="User List"
						buttonText="Export Users"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default User
